import gql from "graphql-tag";

const ORGANIZATION = gql`fragment Organization on Organization { id name qualifiedName }`;

export const USER_SERVICE_GET_ORGANIZATIONS = gql`query userService_getOrganizations($userId: Long!) {
  userService_organizations(userId: $userId) { ...Organization }
}
${ORGANIZATION}
`;